import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import Loader from "../../shared/loader";
import Select from "react-select";
import axios from "axios";

const selectStyles = {
  menu: (baseStyles, state) => ({
    ...baseStyles,
    marginTop: 2,
    zIndex: 999,
  }),
};

const PdfList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isAllSelected, setAllSelected] = useState(false);
  const [user, setUser] = useState(null);
  const [listData, setListData] = useState([]);
  const [userDrp, setUserDrp] = useState([]);
  const [seriesDrp, setSeriesDrp] = useState([]);
  const [series, setSeries] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isAllowed, setIsAllowed] = useState(false)

  const fetchUserData = () => {
    setLoading(true);
    axios.post(API_URL.USER_LIST, {}).then((res) => {
      setUserDrp(
        res.data.data.data.map((user) => {
          return {
            label: user.name,
            value: user.id,
          };
        })
      );
      setLoading(false);
    });
  };

  const fetchSeriesData = () => {
    if (!user) {
      return false;
    }
    setLoading(true);
    axios.post(API_URL.SERIES_LIST, { user_id: user }).then((res) => {
      setSeriesDrp(
        res.data.data.map((series) => {
          return {
            label: series.name,
            value: series.id,
          };
        })
      );
      setLoading(false);
    });
  };

  const fetchListData = () => {
    if (!user) {
      return false;
    }
    setLoading(true);
    axios
      .post(API_URL.PRODUCT_LIST, {
        user_id: user,
        series_id: series,
        name: searchValue,
      })
      .then((response) => {
        response.data.data.data.forEach((product) => {
          let existId = selectedProducts.find((r) => (r.id == product.id));
          product.isSelect = existId ? true : false;
        });
        setListData(response.data.data.data);
        setAllSelected(false);
        setLoading(false);
      });
  };

  const handleViewPdf = () => {
    const selecteditem = selectedProducts.map((item) => item.id);
    if (selecteditem.length > 0) {
      navigate(`/admin/pdfview?ids=${selecteditem.join(",")}`);
    }
  };

  const checkUnCheckAll = (isCheck) => {
    if (listData.length > 0) {
      let cpListData = [...listData];
      cpListData.forEach((element) => {
        element.isSelect = isCheck;
      });
      setListData(cpListData);
      viewSelectProduct(cpListData);
    }
  }

  const viewSelectProduct = (listDataArr) => {
    let cpListData = [...listDataArr];
    let cpSelectedProducts = [...selectedProducts];
    cpListData.forEach((element) => {
      let pIndex = cpSelectedProducts.findIndex((row) => row.id == element.id);
      if (element.isSelect) {
        if (pIndex == -1) {
          cpSelectedProducts.push(element);
        }
      } else {
        if (pIndex > -1) {
          cpSelectedProducts.splice(pIndex, 1);
        }
      }
    });
    setSelectedProducts(cpSelectedProducts)
  }

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
        if (!res.data.is_allowed) {
          setUser(res.data.id);
        } else {
          fetchUserData();
        }
      }
    });
  }

  useEffect(() => {
    fetchSeriesData();
    userInfo();
  }, []);

  useEffect(() => {
    user && fetchListData();
  }, [user, series]);

  useEffect(() => {
    if (user) {
      fetchSeriesData(user);
    } else {
      setSeriesDrp([]);
    }
  }, [user]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <div className="w-100">
            <div className="w-100">
              <div>
                <h5>Download Pdf</h5>
              </div>
            </div>
            <div className="w-100 mt-3">
              {(selectedProducts.length > 0) && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                  <div>
                    <span style={{ fontWeight: "bold", color: "#000" }}>Selected Product({selectedProducts.length}): </span>
                    {
                      selectedProducts.map((row, key) => {
                        return <span className="badge bg-dark me-1" key={key}>
                          {row.name}
                        </span>
                      })
                    }
                  </div>
                  <button
                    style={{ minWidth: '100px' }}
                    className="btn btn-sm btn-primary "
                    onClick={handleViewPdf}
                  >
                    View Pdf
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex">
        {isAllowed && <div className="form-group me-3" style={{ width: "300px" }}>
          <Select
            options={userDrp}
            placeholder="Select User..."
            value={userDrp.find((d) => d.value === user)}
            styles={selectStyles}
            onChange={(e) => {
              setSelectedProducts([]);
              setUser(e.value);
            }}
          />
        </div>}
        <div className="form-group me-3" style={{ width: "300px" }}>
          <Select
            options={seriesDrp}
            placeholder="Select Series..."
            value={seriesDrp.find((d) => d.value === series)}
            styles={selectStyles}
            onChange={(e) => {
              setSeries(e.value);
            }}
          />
        </div>
        <div className="form-group" style={{ width: "300px" }}>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                fetchListData();
              }
            }}
            className="form-control"
            placeholder="Search"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading ? (
                <Loader></Loader>
              ) : (
                <div>
                  <div className="table-responsive">
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setAllSelected(e.target.checked);
                                checkUnCheckAll(e.target.checked);
                              }}
                              checked={isAllSelected}
                            />
                          </th>
                          <th>Image</th>
                          <th>Product</th>
                          <th>Series</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listData.map((row, key) => {
                          return (
                            <tr key={key}>
                              <td className="td-chackbox">
                                <input
                                  type="checkbox"
                                  checked={row.isSelect}
                                  onChange={(event) => {
                                    const copyData = [...listData];
                                    copyData[key].isSelect =
                                      event.target.checked;
                                    setListData(copyData);
                                    viewSelectProduct(copyData);
                                  }}
                                />
                              </td>
                              <td className="td-avatar">
                                <div
                                  style={{
                                    backgroundImage: "url(" + row.image + ")",
                                  }}
                                ></div>
                              </td>
                              <td>{row.name}</td>
                              <td>{row?.series?.name}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfList;
